export default "__VITE_ASSET__b68f726d__"